export const PIPELINE_STAGE_NEW = 'NEW';
export const PIPELINE_STAGE_CONTACTED = 'CONTACTED';
export const PIPELINE_STAGE_QUALIFIED = 'QUALIFIED';
export const PIPELINE_STAGE_ESTIMATE_SCHEDULED = 'ESTIMATE_SCHEDULED';
export const PIPELINE_STAGE_ESTIMATE_SENT = 'ESTIMATE_SENT';
export const PIPELINE_STAGE_FOLLOW_UP = 'FOLLOW_UP';
export const PIPELINE_STAGE_BOOKED = 'BOOKED';
export const PIPELINE_STAGE_LOST = 'LOST';

export const PIPELINE_STAGES = [
  PIPELINE_STAGE_NEW,
  PIPELINE_STAGE_CONTACTED,
  PIPELINE_STAGE_QUALIFIED,
  PIPELINE_STAGE_ESTIMATE_SCHEDULED,
  PIPELINE_STAGE_ESTIMATE_SENT,
  PIPELINE_STAGE_FOLLOW_UP,
  PIPELINE_STAGE_BOOKED,
  PIPELINE_STAGE_LOST,
];

export const PIPELINE_BOARD_STAGES = [
  PIPELINE_STAGE_NEW,
  PIPELINE_STAGE_CONTACTED,
  PIPELINE_STAGE_QUALIFIED,
  PIPELINE_STAGE_ESTIMATE_SCHEDULED,
  PIPELINE_STAGE_ESTIMATE_SENT,
  PIPELINE_STAGE_FOLLOW_UP,
  PIPELINE_STAGE_BOOKED,
];

export const PIPELINE_STAGE_LABELS = {
  [PIPELINE_STAGE_NEW]: 'New',
  [PIPELINE_STAGE_CONTACTED]: 'Contacted',
  [PIPELINE_STAGE_QUALIFIED]: 'Qualified',
  [PIPELINE_STAGE_ESTIMATE_SCHEDULED]: 'Estimate Scheduled',
  [PIPELINE_STAGE_ESTIMATE_SENT]: 'Estimate Sent',
  [PIPELINE_STAGE_FOLLOW_UP]: 'Follow Up',
  [PIPELINE_STAGE_BOOKED]: 'Booked',
  [PIPELINE_STAGE_LOST]: 'Lost',
};

export const normalizePipelineStage = (value) => {
  const stage = String(value || '').trim().toUpperCase();
  return PIPELINE_STAGES.includes(stage) ? stage : PIPELINE_STAGE_NEW;
};

export const getPipelineStageLabel = (value) => {
  const stage = normalizePipelineStage(value);
  return PIPELINE_STAGE_LABELS[stage] || PIPELINE_STAGE_LABELS[PIPELINE_STAGE_NEW];
};
